module.exports = __webpack_public_path__ + "static/media/green-box2.c23b595f.jpg";